<template>
  <div class="container page-container" v-if="dataReady">

    <el-row :gutter="10">
      <el-col :xs="24" :sm="24" :md="24" :lg="24">
        <h1 @click="deleteFormVisible = true">{{user.email}}</h1>
        <br>
        <el-checkbox v-model="user.isAdmin" @change="updateUserRole"> Admin</el-checkbox><br>
        <div class="project-select" v-if="user.isAdmin !== true">
          <h3>Projects</h3>
          <ul v-if="projects">
            <li v-for="(project, index) in projects">
              <el-checkbox v-model="project.users[user['.key']]" @change="updateUserProjects(project, user['.key'])"> {{project.name}}</el-checkbox>
            </li>
          </ul>
        </div>
        <br>
<!--         <el-button size="large" @click.prevent="$router.push('/users')" icon="delete"> Remove User</el-button><br><br>
 -->        <el-button size="large" @click.prevent="$router.push('/users')" icon="arrow-left"> Back to Users</el-button>
      </el-col>
    </el-row>

    <el-dialog title="Are You Sure You Want To Delete This User?" :visible.sync="deleteFormVisible">
      <el-form :inline="true" :label-position="labelPosition">
        <p>You will also need to delete the user in the <a class="link-out" href="http://console.firebase.google.com" target="_blank">Firebase console</a>.</p>
        <el-button @click="deleteFormVisible = false">No Way, Get Me Out Of Here!</el-button>
        <el-button type="danger" @click="deleteUser()">Delete</el-button>

      </el-form>
    </el-dialog>

  </div>
</template>
<script>
  import moment from 'moment'
  import { db, authService } from '../helpers/helpers'

  let userRef
  let projectsRef = db.ref('projects')

  export default {
    name: 'user',

    firebase: {
      projects: projectsRef
    },

    data () {
      return {
        auth: authService,
        labelPosition: 'top',
        deleteFormVisible: false,
        dataReady: false
      }
    },

    created () {
      userRef = db.ref(this.$route.path)
      this.$bindAsObject('user', userRef)
      this.$bindAsArray('userProjects', projectsRef.orderByChild('users/' + this.auth.user.uid).equalTo(true))
      this.dataReady = true
    },

    methods: {
      prettyDate (date) {
        return moment(date).format('MMMM Do YYYY, h:mm:ss a')
      },
      updateUserRole () {
        let userRole = this.user.isAdmin
        this.$firebaseRefs.user.child('isAdmin').remove()
        this.$firebaseRefs.user.child('isAdmin').set(userRole)
      },
      updateUserProjects (project, uid) {
        let ref = this.$firebaseRefs.projects.child(project['.key']).child('users/')
        ref.once('value')
          .then(function (snapshot) {
            // console.log(snapshot.child(uid).val())
            if (snapshot.child(uid).val() === null) {
              ref.update({ [uid]: true })
            } else {
              ref.update({ [uid]: project.users[uid] })
            }
          })
      },
      deleteUser () {
        this.auth.userDelete(this.user['.key'])
      }
    }

  }
</script>

<style scoped>

  h1 {
    display:  inline-block;
    cursor:  pointer;
  }

  .el-switch__label * {
    font-size:  9px;
    line-height:  1.6em;
  }

  ul, li {
    margin:  0;
    padding:  0;
  }

  ul li {
    list-style:  none;
  }

  .link-out {
    text-decoration: none
  }

</style>


// WEBPACK FOOTER //
// User.vue?5cda8654